import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config/apiBase";
import API from "../utils/axiosInstance";

const AdminCourseSchedule = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();

  const [schedules, setSchedules] = useState([]);
  const [form, setForm] = useState({
    title: "",
    date: "",
    time: "",
  });
  const [students, setStudents] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);


  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || !user.isAdmin) {
      alert("Access denied. Admin only.");
      navigate("/dashboard");
    } else {
      fetchSchedules();
      fetchStudents();
    }
  }, [navigate, courseId]);

  const fetchStudents = async () => {
    try {
      const res = await API.get(`/courses/${courseId}/students`);
      setStudents(res.data); // Each should be { id, name } or similar
    } catch (err) {
      console.error("Failed to load students", err);
    }
  };

  const fetchSchedules = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/schedules/course/${courseId}`);
      setSchedules(res.data);
    } catch (err) {
      console.error("Failed to load schedules", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    try {
      if (editingId) {
        await axios.put(`${API_BASE_URL}/schedules/${editingId}`, form, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        await axios.post(`${API_BASE_URL}/schedules`, {
          ...form,
              userIds: selectedUserIds,
          courseId,
        }, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
      setForm({ title: "", date: "", time: "" });
      setEditingId(null);
      fetchSchedules();
    } catch (err) {
      console.error("Error saving schedule", err);
      alert("Failed to save schedule");
    }
    setSelectedUserIds([]);
  };

  const handleEdit = (session) => {
    setForm({ title: session.title, date: session.date, time: session.time });
    setEditingId(session.id);
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");
    if (window.confirm("Are you sure you want to delete this session?")) {
      try {
        await axios.delete(`${API_BASE_URL}/schedules/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        fetchSchedules();
      } catch (err) {
        console.error("Delete failed", err);
        alert("Failed to delete schedule");
      }
    }


  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-10 px-4">
      <div className="bg-white shadow-md rounded-lg p-8 w-full max-w-4xl">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Manage Course Schedule</h2>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <input
            type="text"
            placeholder="Class Title"
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
            required
            className="border border-gray-300 p-3 rounded-md"
          />
          <select
            multiple
            value={selectedUserIds}
            onChange={(e) =>
              setSelectedUserIds([...e.target.selectedOptions].map(opt => parseInt(opt.value)))
            }
            className="border border-gray-300 p-3 rounded-md col-span-full"
          >
            {students.map((user) => (
              <option key={user.id} value={user.id}>
                {user.firstName} {user.lastName}
              </option>
            ))}
          </select>

          <input
            type="date"
            value={form.date}
            onChange={(e) => setForm({ ...form, date: e.target.value })}
            required
            className="border border-gray-300 p-3 rounded-md"
          />
          <input
            type="time"
            value={form.time}
            onChange={(e) => setForm({ ...form, time: e.target.value })}
            required
            className="border border-gray-300 p-3 rounded-md"
          />

          <button
            type="submit"
            className="col-span-full bg-blue-600 text-white font-semibold py-3 rounded-md hover:bg-blue-700"
          >
            {editingId ? "Update Session" : "Add Session"}
          </button>
        </form>

        <table className="w-full table-auto border text-sm text-left">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-2 border">Week</th>
              <th className="p-2 border">Title</th>
              <th className="p-2 border">Date</th>
              <th className="p-2 border">Time</th>
              <th className="p-2 border">Join Link</th>
              <th className="p-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {schedules.map((s, i) => (
              <tr key={s.id} className="border-t">
                <td className="p-2 border">{i + 1}</td>
                <td className="p-2 border">{s.title}</td>
                <td className="p-2 border">{s.date}</td>
                <td className="p-2 border">{s.time}</td>
                <td className="p-2 border">
                  <a href={s.joinLink} target="_blank" rel="noreferrer" className="text-blue-600 underline">
                    Join
                  </a>
                </td>
                <td className="p-2 border space-x-2">
                  <button onClick={() => handleEdit(s)} className="text-yellow-600">Edit</button>
                  <button onClick={() => handleDelete(s.id)} className="text-red-600">Delete</button>
                </td>
              </tr>
            ))}
            {schedules.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center py-6 text-gray-500">No sessions added yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminCourseSchedule;
